import React, { useState } from "react";
// import { useParams, useNavigate } from "react-router-dom";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import "../css/PediatricAssessmentScreen.css";

// Import the components for each tab
import MallampatiTab from "../components/pediatric/MallampatiTab";
import TeleAuscultationTab from "../components/pediatric/TeleAuscultationTab";
import AsthmaIndexTab from "../components/pediatric/AsthmaIndexTab";
import FinalReviewTab from "../components/pediatric/FinalReviewTab";

type ActiveTab = "mallampati" | "auscultation" | "asthma" | "review";

const PediatricAssessmentScreen: React.FC = () => {
  const { emrNumber } = useParams<{ emrNumber: string }>();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<ActiveTab>("mallampati");

  const renderActiveTab = () => {
    switch (activeTab) {
      // ONLY change inside renderActiveTab()
      case "mallampati":
        return <MallampatiTab onSuccess={() => setActiveTab("auscultation")} />;

      // ONLY change inside renderActiveTab()

      case "auscultation":
        return <TeleAuscultationTab onSuccess={() => setActiveTab("asthma")} />;

      case "asthma":
        return <AsthmaIndexTab />;
      case "review":
        return <FinalReviewTab />;
      // FIX: Add a default case to ensure the function always returns a valid ReactNode.
      default:
        return null;
    }
  };

  return (
    <div className="assessment-screen">
      <div className="screen-header-row">
        <button
          onClick={() => navigate("/queues/PEDIATRIC_RESIDENT")}
          className="back-button"
        >
          &larr; Back to Patient List
        </button>
        <div className="patient-info">
          <span>
            <strong>EMR Number:</strong> {emrNumber}
          </span>
          <span>
            <strong>Age:</strong> 4 years
          </span>
        </div>
      </div>

      <div className="assessment-tabs-container">
        <button
          className={`assessment-tab ${activeTab === "mallampati" ? "active" : ""}`}
          onClick={() => setActiveTab("mallampati")}
        >
          Mallampati Classification
        </button>
        <button
          className={`assessment-tab ${activeTab === "auscultation" ? "active" : ""}`}
          onClick={() => setActiveTab("auscultation")}
        >
          Tele-Auscultation
        </button>
        <button
          className={`assessment-tab ${activeTab === "asthma" ? "active" : ""}`}
          onClick={() => setActiveTab("asthma")}
        >
          Modified Asthma Predictive Index
        </button>
        {/* <button
          className={`assessment-tab ${activeTab === "review" ? "active" : ""}`}
          onClick={() => setActiveTab("review")}
        >
          Final Review & Approval
        </button> */}
      </div>

      <div className="assessment-content">{renderActiveTab()}</div>
    </div>
  );
};

export default PediatricAssessmentScreen;
